<template>
  <el-dialog title="选择收货信息"
             :visible.sync="visible"
             width="640px"
             append-to-body
             @closed="handleClosed">
    <template v-if="visible">
      <el-steps :active="active"
                align-center
                finish-status="success">
        <el-step title="选择客户"></el-step>
        <el-step title="选择地址"></el-step>
      </el-steps>
      <product-select-list v-if="active === 0"
                           @select="onSelectProduct" />
      <package-select-list v-if="active === 1"
                           :options="currentProduct"
                           @select="onSelectPackage" />
    </template>
    <div slot="footer">
      <span v-if="currentProduct.dealerId"
            style="font-size: 13px;margin-right: 10px;color: #666;font-weight: 600">
        已选客户：{{ currentProduct.dealerName }}
      </span>
      <el-button @click="visible = false">取 消</el-button>
      <!-- <el-button v-if="active === 0"
                 type="primary"
                 @click="next">下一步</el-button> -->
      <el-button v-if="active === 1"
                 @click="handleClosed">上一步</el-button>
      <!-- <el-button v-if="active === 1"
                 type="primary"
                 @click="add">确 定</el-button> -->
    </div>
  </el-dialog>
</template>
<script>
import PackageSelectList from './package-select-list.vue'
import ProductSelectList from './product-select-list.vue'
export default {
  name: 'PackageSelectModal',
  components: { ProductSelectList, PackageSelectList },
  props: {
    callback: Function
  },
  data () {
    return {
      active: 0,
      loading: false,
      visible: false,
      currentProduct: {},
      currentPackage: {}
    }
  },
  methods: {
    handleClosed () {
      this.active = 0
      this.currentProduct = {}
      this.currentPackage = {}
    },
    onSelectProduct (row) {
      this.currentProduct = { ...row }
      this.active = 1
    },
    onSelectPackage (row) {
      this.currentPackage = { ...row }
      this.visible = false
      this.active = 0
      this.$emit('select', { ...this.currentProduct, ...this.currentPackage })
    },
    // next () {
    //   if (!this.currentProduct.dealerId) {
    //     this.$message.error('请选择一个客户')
    //     return
    //   }
    //   this.active = 1
    // },
    // add () {
    //   if (!this.currentPackage.deliveryAddressId) {
    //     this.$message.error('请选择一个地址')
    //     return
    //   }
    //   this.callback && this.callback(this.currentPackage, 'package')
    //   this.active = 0
    //   this.visible = false
    // },
    fetch (options = {}) {
      this.visible = true
      // setTimeout(() => {
      //   this.$refs.product.fetch(options)
      // }, 20)
    }
  }
}
</script>
